import {OptionLanguageInputSwitcher} from "../components/Localization/OptionLanguageInputSwitcher";

/**
 * Localize
 * @param text
 * @return {*}
 */
export const __loco = (text) => {
    if(!!window.LocalizationConfig && !!window.LocalizationConfig['strings']  && !!window.LocalizationConfig['strings'][text]) {
        return window.LocalizationConfig['strings'][text];
    } else {
        return text;
    }
};

/**
 * Get currency
 * @return {string|*}
 */
export const getCurrency = () => {
    if(!!window.LocalizationConfig && !!window.LocalizationConfig['currency']) {
        return window.LocalizationConfig['currency'];
    } else {
        return __loco('NOK');
    }
};

export const getCurrentLocale = () => {
    if(!!window.LocalizationConfig && !!window.LocalizationConfig['locale']) {
        return window.LocalizationConfig['locale'];
    } else {
        return 'en';
    }
};


export const getPrimaryLanguage = () => {
    if(!!window.LocalizationConfig && !!window.LocalizationConfig['primary_language']) {
        return window.LocalizationConfig['primary_language'];
    } else {
        return 'de';
    }
};

export const localizedOrRawValue = (value) => {
    if(typeof value === 'string') {
        return value;
    }
    if(typeof value === 'object' && !!value[getPrimaryLanguage()]) {
        return OptionLanguageInputSwitcher.getString(value);
    }
    return value
}